'use client';
import { useEffect, useState } from 'react';
import ItemComp from './ItemComp';

export default function Content({ id, data = {}, list = [], initIndex = 0, isEditStatus }: any) {
    const { isAuto, wholeBG = '#3f68e0' } = data;
    const [active, setActive] = useState(initIndex);

    const handlePrev = () => {
        setActive(active <= 0 ? list?.length - 1 : active - 1);
    };

    const handleNext = () => {
        setActive(active + 1 >= list?.length ? 0 : active + 1);
    };

    useEffect(() => {
        if (isAuto) {
            const timer = setTimeout(() => {
                setActive(active + 1 >= list?.length ? 0 : active + 1);
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [active, isAuto]);

    return (
        <ul className={`global-bar-top-lists-Y isEditStatus-${isEditStatus} isAuto-${isAuto}`} style={wholeBG ? { background: wholeBG } : {}}>
            {list?.map((item: any, i: number) => (
                <li className={`global-bar-top-list ${active === i ? 'active' : ''}`} key={i}>
                    <ItemComp id={id} data={item} index={i} />
                </li>
            ))}
            {!isAuto && (
                <div className="navigation-btns">
                    <span className="btn prev" onClick={handlePrev}></span>
                    <span className="btn next" onClick={handleNext}></span>
                </div>
            )}
        </ul>
    );
}
